import { RVIcon, RVIconSizeOptions } from "../RVIcon/RVIcon";

import type { WrapperTooltipProps } from "antd/es/form/FormItemLabel";

import styles from "./RVFormItem.module.scss";

/**
 * Standardizes the tooltip configuration for Form.Item components.
 * Ensures consistent tooltip appearance and proper positioning with required field markers.
 *
 * @param title - Tooltip content (string or JSX)
 * @param required - Whether the field is required (affects positioning)
 * @returns Standardized tooltip configuration for Form.Item
 */
export function getFormItemTooltipConfig(title: string | JSX.Element, required = false): WrapperTooltipProps {
    return {
        title,
        icon: <RVIcon icon="info-circle" size={RVIconSizeOptions.SMALL} />,
        ...(required ? { className: styles.requiredMarkAwareTooltip } : {}),
    };
}
